import clsx from 'clsx';
import { ComponentProps } from 'react';

type Props = {
  html?: string;
} & ComponentProps<'div'>;

function RawHtml(props: Props) {
  const { html = '', className, ...rest } = props;

  return <div {...rest} className={clsx('flow', className)} dangerouslySetInnerHTML={{ __html: html }} />;
}

export default RawHtml;
